module.exports = __webpack_public_path__ + "media/control_acceso/cortina_labeled-2693a99e.png";